export const vendorsPtBr = {
  common: {
    loading: 'Carregando...',
    save: 'Salvar',
    cancel: 'Cancelar',
    edit: 'Editar',
    delete: 'Excluir',
    add: 'Adicionar',
    create: 'Criar',
    update: 'Atualizar',
    back: 'Voltar',
    actions: 'Ações',
    search: 'Pesquisar',
    noResults: 'Nenhum resultado encontrado',
    download: 'Download',
  },
  selector: {
    label: 'Fornecedor',
    placeholder: 'Selecione um fornecedor',
    emptyMessage: 'Nenhum fornecedor disponível.',
    notFoundMessage: 'Nenhum fornecedor encontrado.',
    searchError: 'Erro ao buscar fornecedores',
    removeVendorAria: 'Remover fornecedor',
    searchPlaceholder: 'Buscar por nome, fantasia ou documento...',
    loading: 'Buscando fornecedores...',
    createVendor: 'Criar fornecedor "{{searchTerm}}"',
    resultsLabel: 'Fornecedores',
    selectedCount: '{{count}} selecionados',
    clearSelectionAria: 'Limpar seleção',
  },
  errors: {
    loadVendors: 'Erro ao carregar fornecedores',
    loadVendor: 'Erro ao carregar fornecedor',
    createVendor: 'Erro ao criar fornecedor',
    duplicateCpf: 'Já existe um fornecedor com esse CPF',
    duplicateCnpj: 'Já existe um fornecedor com esse CNPJ',
    duplicateVendorCode: 'Código de fornecedor já existe',
    internationalIdentityRequired:
      'Informe o país e o identificador fiscal estrangeiro para ativar este fornecedor.',
    collaboratorEntityRequired: 'Selecione a entidade do colaborador para continuar.',
    updateVendor: 'Erro ao atualizar fornecedor',
    deleteVendor: 'Erro ao excluir fornecedor',
    mergeVendors: 'Não foi possível mesclar os fornecedores',
    mergePreview: 'Não foi possível carregar os dados para mesclagem',
    inactivateVendor: 'Erro ao inativar fornecedor',
    loadMergeHistory: 'Erro ao carregar histórico de mesclagem',
    loadDocuments: 'Erro ao carregar documentos',
    createDocument: 'Erro ao criar documento',
    updateDocument: 'Erro ao atualizar documento',
    deleteDocument: 'Erro ao excluir documento',
    loadDocumentTypes: 'Erro ao carregar tipos de documento',
    downloadUnavailable: 'URL de download não disponível',
    fileRequired: 'Arquivo é obrigatório para novos documentos',
    documentTypeRequired: 'Tipo de documento é obrigatório',
    loadDuplicates: 'Erro ao carregar possíveis duplicatas',
    dismissDuplicate: 'Erro ao dispensar.',
  },
  success: {
    vendorCreated: 'Fornecedor criado com sucesso',
    vendorUpdated: 'Fornecedor atualizado com sucesso',
    vendorInactivated: 'Fornecedor inativado com sucesso',
    vendorsMerged: 'Fornecedores mesclados com sucesso',
    documentCreated: 'Documento criado com sucesso',
    documentUpdated: 'Documento atualizado com sucesso',
    documentDeleted: 'Documento excluído com sucesso',
  },
  pages: {
    vendors: {
      title: 'Fornecedores',
      createButton: 'Criar fornecedor',
      searchPlaceholder: 'Pesquisar por nome, CPF/CNPJ, email...',
      listing: {
        subtitle: 'Fornecedores e prestadores de serviço da empresa',
        create: 'Novo fornecedor',
        moreActions: 'Mais ações',
        views: 'Status dos fornecedores',
        viewAll: 'Todos',
        duplicates: 'Possíveis duplicatas',
        status: {
          ACTIVE: 'Ativos',
          INACTIVE: 'Inativos',
          BLOCKED: 'Bloqueados',
          UNDER_REVIEW: 'Em análise',
        },
        statusBadge: {
          ACTIVE: 'Ativo',
          INACTIVE: 'Inativo',
          BLOCKED: 'Bloqueado',
          UNDER_REVIEW: 'Em análise',
        },
        columns: {
          name: 'Nome',
          taxIdType: 'Tipo',
          document: 'CPF/CNPJ',
          vendorType: 'Tipo de fornecedor',
          establishment: 'Estabelecimento',
          email: 'E-mail',
          phone: 'Telefone',
          status: 'Status',
        },
        taxIdType: {
          CNPJ: 'Pessoa jurídica',
          CPF: 'Pessoa física',
          ACRONYM: 'Sigla',
          INTERNATIONAL: 'Estrangeiro',
          RFC: 'Estrangeiro (RFC)',
          EIN: 'Estrangeiro (EIN)',
        },
        vendorType: {
          SUPPLIER: 'Fornecedor',
          SERVICE_PROVIDER: 'Prestador de serviço',
          BOTH: 'Fornecedor e prestador',
          GOVERNMENT_ENTITY: 'Órgão público',
          BANK_FEE: 'Tarifa bancária',
        },
        establishment: {
          HEADQUARTERS: 'Matriz',
          BRANCH: 'Filial',
          NONE: 'Não informado',
        },
        collaboratorFilter: {
          label: 'Colaboradores',
          only: 'Apenas colaboradores',
          exclude: 'Excluir colaboradores',
        },
        collaborator: 'Colaborador',
        invalidTaxId: '{{type}} inválido',
        searchLabel: 'Pesquisar fornecedores',
        searchPlaceholder: 'Nome, CPF/CNPJ ou e-mail',
        actionsFor: 'Ações de {{name}}',
        edit: 'Editar',
        inactivate: 'Inativar',
        merge: 'Mesclar',
        mergeHint: 'Selecione dois ou mais fornecedores para mesclar',
        nounOne: 'fornecedor',
        nounOther: 'fornecedores',
        emptyTitle: 'Nenhum fornecedor cadastrado',
        emptyDescription: 'Cadastre o primeiro fornecedor para lançar contas a pagar.',
        inactivateTitle: 'Inativar fornecedor',
        inactivateDescription: '{{name}} deixa de aparecer ao lançar novas contas a pagar.',
        inactivateConfirm: 'Inativar',
        cancel: 'Cancelar',
        inactivateError: 'Não foi possível inativar o fornecedor. Tente novamente.',
        inactivated: 'Fornecedor inativado',
        exportError: 'Não foi possível exportar as contas bancárias. Tente novamente.',
      },
      filters: {
        title: 'Filtros',
        taxIdType: {
          label: 'Tipo',
          all: 'Todos',
          cpf: 'CPF',
          cnpj: 'CNPJ',
        },
        status: {
          label: 'Status',
          all: 'Todos',
          active: 'Ativos',
          inactive: 'Inativos',
          blocked: 'Bloqueados',
          underReview: 'Em Análise',
        },
        vendorType: {
          label: 'Tipo Fornecedor',
          all: 'Todos',
          supplier: 'Fornecedor',
          serviceProvider: 'Prestador de Serviço',
          both: 'Ambos',
        },
      },
      establishmentType: {
        label: 'Tipo de Estabelecimento',
        short: 'Tipo Estab.',
        HEADQUARTERS: 'Matriz',
        BRANCH: 'Filial',
      },
      unifyGroupAccounts: {
        label: 'Unificar contas do grupo empresarial',
        description:
          'Quando ativo, contas de todos os CNPJs do mesmo grupo empresarial são consideradas para classificação',
      },
      fiscalTab: {
        emptyTitle: 'Nada para configurar aqui',
        emptyDescription:
          'O grupo empresarial só existe para fornecedores com CNPJ. A classificação fiscal e as regras do fornecedor ficam na aba Regras.',
      },
      collaborator: {
        label: 'Colaborador',
        badge: 'Colaborador',
        filterLabel: 'Classificação',
        filterAll: 'Todos os fornecedores',
        filterOnly: 'Somente colaboradores',
        filterExclude: 'Excluir colaboradores',
        description:
          'Marque fornecedores CLT ou PJ que atuam como colaboradores. Isso não inclui a pessoa automaticamente na folha.',
        entityLabel: 'Entidade do colaborador',
        entityPlaceholder: 'Selecione a entidade',
        // The checkbox previously described only what it does not do. The effect
        // that matters is the concealment it switches on.
        effect:
          'Com a proteção de dados de colaboradores ativa, os valores, documentos e lançamentos deste fornecedor ficam visíveis apenas para quem tem acesso a dados de colaboradores.',
      },
      table: {
        name: 'Nome',
        type: 'Tipo',
        establishmentType: 'Tipo Estab.',
        document: 'CPF/CNPJ',
        email: 'Email',
        phone: 'Telefone',
        status: 'Status',
        select: 'Selecionar',
        actions: 'Ações',
        noVendors: 'Nenhum fornecedor encontrado.',
      },
      mergeWizard: {
        mergeButton: 'Mesclar fornecedores',
        selectVendorsTooltip: 'Selecione dois ou mais fornecedores para mesclar',
        dialogTitle: 'Mesclar fornecedores',
        step1: 'Alvo',
        step2: 'Conflitos',
        step3: 'Confirmar',
        targetHint: 'Escolha o fornecedor que permanecerá após a mesclagem.',
        targetIneligible: 'Cadastro {{status}} não pode receber a mesclagem.',
        noEligibleTargetAlert:
          'Nenhum dos fornecedores selecionados pode receber a mesclagem. Reative ou desbloqueie o cadastro que deve permanecer e tente novamente.',
        targetUnderReview: 'Este cadastro está Em Análise e continuará assim após a mesclagem.',
        activateTarget: 'Ativar este cadastro ao concluir a mesclagem',
        sourceBlocked: 'Não pode ser mesclado para dentro de outro cadastro: {{reasons}}.',
        sourceBlockedHint: 'Escolha-o como alvo ou resolva os vínculos antes de mesclar.',
        blockerReasons: {
          BANK_FEE_CONFIGURATION: 'está vinculado a configuração de tarifa bancária',
          REIMBURSEMENT_REQUESTER: 'é solicitante de reembolso',
          PCC_ACCUMULATOR: 'possui histórico de acumulador PCC',
        },
        legalName: 'Razão social',
        tradeName: 'Nome fantasia',
        document: 'CPF/CNPJ',
        vendorCode: 'Código',
        status: 'Status',
        billCount: 'Contas',
        totalBilled: 'Total faturado',
        next: 'Avançar',
        back: 'Voltar',
        cancel: 'Cancelar',
        loadingPreview: 'Carregando dados…',
        tradeNamePick: 'Nome fantasia (valores diferentes)',
        fromVendor: 'Usar de: {{name}}',
        contactsPick: 'Contatos',
        primaryBlock: 'Contato principal',
        financialBlock: 'Contato financeiro',
        bankAccounts: 'Contas bancárias',
        keepAccount: 'Manter',
        addressPrimary: 'Endereço principal',
        addressLine: '{{street}}, {{number}} — {{city}}/{{state}}',
        confirmIntro: 'Resumo da operação',
        confirmBills_one: '{{count}} conta será reatribuída para {{name}}',
        confirmBills_other: '{{count}} contas serão reatribuídas para {{name}}',
        confirmBillsAmount: 'Total histórico: {{amount}}',
        confirmBanks_one: '{{count}} conta bancária será consolidada no cadastro que permanece',
        confirmBanks_other:
          '{{count}} contas bancárias serão consolidadas no cadastro que permanece',
        confirmDeactivate_one: '{{count}} cadastro será desativado',
        confirmDeactivate_other: '{{count}} cadastros serão desativados',
        confirmGl: 'Lançamentos contábeis (GL) não serão alterados.',
        confirmTargetStays: 'O cadastro que permanece continua {{status}}.',
        confirmTargetActivates: 'O cadastro que permanece passará de Em Análise para Ativo.',
        confirmTaxIdDiverges:
          'Os CPF/CNPJ selecionados são diferentes. A mesclagem afirma que os cadastros são a mesma pessoa e move os identificadores fiscais para o cadastro que permanece. Confirme que é isso mesmo antes de continuar.',
        confirmWarning: 'Esta operação não pode ser desfeita pelo sistema.',
        confirmButton: 'Confirmar mesclagem',
        merging: 'Mesclando…',
        resultBills_one: '{{count}} conta reatribuída',
        resultBills_other: '{{count}} contas reatribuídas',
        resultBanks_one: '{{count}} conta bancária consolidada',
        resultBanks_other: '{{count}} contas bancárias consolidadas',
        resultDeactivated_one: '{{count}} cadastro desativado',
        resultDeactivated_other: '{{count}} cadastros desativados',
        successWarnings_one:
          '{{count}} item não pôde ser consolidado. Revise o cadastro que permaneceu.',
        successWarnings_other:
          '{{count}} itens não puderam ser consolidados. Revise o cadastro que permaneceu.',
        resultTitle: 'Mesclagem concluída',
        resultActivated: 'O cadastro que permaneceu foi ativado.',
        resultDone: 'Concluir',
        noPreview: 'Não foi possível carregar o resumo. Tente novamente.',
        validation: {
          pickTarget: 'Selecione o fornecedor alvo.',
          noEligibleTarget:
            'Nenhum fornecedor selecionado pode receber a mesclagem (apenas Ativos e Em Análise).',
          sourceBlocked:
            '{{name}} não pode ser mesclado para dentro de outro cadastro. Escolha-o como alvo ou resolva os vínculos antes.',
          keepOneBank: 'Mantenha pelo menos uma conta bancária.',
          pickPrimary: 'Selecione um endereço principal.',
          duplicateBank:
            'Há contas bancárias duplicadas (banco/agência/conta) na seleção. Ajuste antes de continuar.',
        },
      },
      confirmations: {
        inactivate: 'Inativar fornecedor {{name}}?\nEssa ação pode ser revertida futuramente.',
      },
      duplicates: {
        tab: 'Possíveis duplicatas',
        badge: '{{count}} grupos duplicados',
        alert: '{{count}} grupo(s) de possíveis duplicatas encontrado(s).',
        reviewButton: 'Revisar possíveis duplicatas',
        viewAll: 'Ver todos',
        empty: 'Nenhum grupo de duplicatas encontrado.',
        taxId: 'Documento',
        similarity: 'similaridade',
        expandHint_one: '{{count}} fornecedor',
        expandHint_other: '{{count}} fornecedores',
        reviewMerge: 'Revisar e mesclar',
        dismiss: 'Dispensar',
        dismissToast: 'Grupo dispensado.',
        table: {
          code: 'Código',
          name: 'Nome',
          status: 'Status',
          bills: 'Contas',
        },
        wizard: {
          title: 'Mesclar fornecedores',
          description:
            'Os demais cadastros deste grupo serão inativados e contas, endereços e dados relacionados serão movidos para o fornecedor mantido.',
          targetLabel: 'Manter este fornecedor',
          targetIneligible: 'Não pode receber a mesclagem.',
          blockedSources_one:
            'Não é possível mesclar: {{details}}. Escolha-o como alvo ou resolva os vínculos antes.',
          blockedSources_other:
            'Não é possível mesclar: {{details}}. Escolha um deles como alvo ou resolva os vínculos antes.',
          cancel: 'Cancelar',
          confirm: 'Mesclar',
          merging: 'Mesclando...',
        },
      },
    },
    vendorForm: {
      create: {
        title: 'Novo Fornecedor',
        description: 'Preencha os dados para criar um novo fornecedor',
      },
      edit: {
        title: 'Editar Fornecedor',
        description: 'Atualize as informações do fornecedor',
      },
      tabs: {
        basic: 'Informações Básicas',
        tax: 'Dados Fiscais',
        contact: 'Contatos',
        payment: 'Pagamento',
        withholdings: 'Retenções',
        fiscal: 'Classificação Fiscal',
        additional: 'Adicionais',
        addresses: 'Endereços',
        bankAccounts: 'Contas Bancárias',
        documents: 'Documentos',
      },
      sections: {
        basic: {
          description: 'Dados cadastrais principais do fornecedor.',
        },
        tax: {
          description: 'Inscrições, regime tributário e contribuições fiscais.',
        },
        contact: {
          description: 'Contatos principal, financeiro e website.',
        },
        payment: {
          description: 'Preferências de pagamento e limite de crédito.',
        },
        fiscal: {
          description: 'Classificações padrão para documentos fiscais.',
        },
        additional: {
          description: 'Risco, desempenho e observações internas.',
        },
        addresses: {
          description: 'Endereços vinculados ao cadastro do fornecedor.',
        },
        bankAccounts: {
          description: 'Dados bancários para pagamentos do fornecedor.',
        },
      },
      saveButton: 'Salvar',
      cancelButton: 'Cancelar',
      saving: 'Salvando...',
      foreignTaxId: 'Identificador fiscal estrangeiro',
      foreignTaxIdPlaceholder: 'Ex.: 12-3456789',
      country: 'País',
      countryPlaceholder: 'Selecione o país',
      foreignTaxRegime: 'Estrangeiro',
    },
    recurringBills: {
      tabTitle: 'Recorrência',
      emptyState: 'Nenhum template de conta recorrente encontrado',
      createNew: 'Criar nova recorrência',
      edit: 'Editar',
      deactivate: 'Inativar',
      reactivate: 'Reativar',
      editDialogTitle: 'Editar conta recorrente',
      createDialogTitle: 'Criar conta recorrente',
      createFromBillDialogTitle: 'Criar conta recorrente a partir desta conta',
      editDialogDescription: 'Altere o nome e os termos da conta recorrente.',
      form: {
        name: 'Nome',
        namePlaceholder: 'Ex: Conta de telefonia móvel',
        description: 'Descrição',
        descriptionPlaceholder: 'Descrição detalhada (opcional)',
        addDescription: 'Adicionar descrição',
        createdAt: 'criada em {{date}}',
        statusActive: 'Ativa',
        statusPaused: 'Pausada',
        tabs: {
          recurrence: 'Recorrência',
          classification: 'Classificação',
          linkedBills: 'Contas vinculadas',
        },
        continueTo: 'Continuar: {{tab}}',
        requiredPending: '{{count}} campo(s) obrigatório(s) em {{tab}}',
        openEndedSummary: 'Sem data final, a reserva é indefinida.',
        summary: {
          frequency: 'Frequência',
          firstPeriod: 'Primeiro período',
          periods: 'Períodos',
          totalReserved: 'Reserva total',
          day: 'dia {{day}}',
          indefinite: 'Indefinido',
          hasEnd: 'com data final',
          noEnd: 'sem data final',
          withRetroactive: 'inclui períodos anteriores',
          withoutRetroactive: 'sem períodos anteriores',
          perPeriod: '{{amount}} por período',
        },
        linkedBillsHelp:
          'Contas que já usaram este template e o que cada período consumiu do orçamento reservado.',
        linkedBillsPeriod: 'Período',
        linkedBillsBill: 'Conta',
        linkedBillsReserved: 'Reservado',
        linkedBillsRealized: 'Realizado',
        linkedBillsEmpty: 'Nenhuma conta vinculada ou período previsto ainda.',
        linkedBillsAwaiting: 'Aguardando cobrança',
        linkedBillsProjectedStatus: 'Prevista',
        amount: 'Valor recorrente esperado',
        amountVariable: 'Valor médio recorrente esperado',
        amountTooltip: 'O valor contratado/esperado para cada conta dessa recorrência',
        amountTooltipVariable:
          'Valor médio esperado para cada conta quando a recorrência é variável',
        amountTooltipAria: 'Ajuda: valor recorrente esperado',
        amountTooltipVariableAria: 'Ajuda: valor médio recorrente esperado',
        recurrenceType: 'Tipo de recorrência',
        recurrenceTypeFixedTitle: 'Fixa',
        recurrenceTypeFixedDescription: 'Valor contratado. Variação compara vs. valor esperado.',
        recurrenceTypeVariableTitle: 'Variável',
        recurrenceTypeVariableDescription: 'Valor muda. Variação compara vs. média recente.',
        variableComparisonMonths: 'Calc. variação c/base em últimos:',
        variableComparisonMonthsTooltip:
          'O sistema usará esse número de meses para comparar a variação de cada conta',
        variableComparisonMonthsTooltipAria: 'Ajuda: meses para comparação de variação',
        recurringBillType: 'Natureza da recorrência',
        recurringBillTypeHelp:
          'Recorrências de folha ficam visíveis apenas para quem tem acesso a dados de folha.',
        naturezaChangeConfirmTitle: 'Alterar a Natureza deste template?',
        naturezaChangeConfirmBody:
          'Alterar a Natureza reclassifica como o histórico deste contrato aparece nos relatórios de FP&A (folha vs. recorrente/residual), incluindo períodos já encerrados. Se você não quiser reclassificar os meses passados, encerre esta recorrência e crie uma nova com a Natureza correta.',
        naturezaChangeConfirmConfirm: 'Alterar Natureza mesmo assim',
        headcountPosition: 'Vincular a uma Posição do Plano de Contratações',
        headcountPositionNone: 'Nenhuma',
        headcountPositionHint:
          'Só aparecem Posições PJ ainda Planejadas desta entidade. Vincular contrata a Posição ao salvar.',
        entity: 'Entidade',
        entityPlaceholder: 'Selecione a entidade',
        payrollFrequencyHint: 'As recorrências de folha são sempre mensais.',
        frequency: 'Frequência',
        status: 'Status',
        paymentTermDays: 'Dias para pagamento',
        paymentTermAutomatic: 'Automático',
        paymentTermDaysHelp:
          'Prazo D+X em dias corridos a partir da competência, usado nas projeções de caixa. Deixe vazio para usar o histórico de pagamentos da recorrência; sem histórico, o calendário da entidade ou a própria competência. Pagamentos agendados e vencimentos documentais têm prioridade.',
        expectedDueDayOfMonth: 'Dia esperado de vencimento',
        expectedDueDayOfMonthPlaceholder: 'Ex: 10',
        expectedCompetencyDayOfMonth: 'Dia esperado de competência',
        expectedCompetencyDayOfMonthPlaceholder: 'Ex: 5',
        recurringSince: 'Início',
        recurringSinceHelp:
          'Opcional. Quando vazio, o sistema usa a data de criação do template como início.',
        recurringUntilHelp: 'Deixe vazio para fim indeterminado',
        retroactiveConfirmTitle: 'Criar compromissos retroativos?',
        retroactiveConfirmBody:
          'Como a recorrência começa em um período anterior ao atual, deseja criar compromissos orçamentários em períodos retroativos?',
        retroactiveConfirmOpenLabel: 'Serão incluídos (períodos abertos): {{periods}}',
        retroactiveConfirmClosedLabel:
          'Os seguintes períodos serão ignorados por estarem fechados:',
        retroactiveConfirmFallback:
          'Não foi possível pré-carregar os períodos. Se confirmar, o sistema tentará incluir apenas períodos passados abertos.',
        createWithoutBackfill: 'Reservar apenas orçamento atual/futuro',
        createWithBackfill: 'Reservar orçamento retroativo',
        retroactiveDecisionTitle: 'O início inclui {{count}} períodos anteriores',
        retroactiveDecisionDescription:
          'Escolha como o orçamento deve tratar os períodos anteriores.',
        retroactiveDecisionCurrentFutureTitle: 'Não reservar períodos anteriores',
        retroactiveDecisionCurrentFutureDescription:
          'Os períodos anteriores ficam sem compromisso. As contas já lançadas neles não mudam.',
        retroactiveDecisionIncludeTitle: 'Incluir {{count}} períodos abertos',
        retroactiveDecisionIncludeDescription:
          'Cria compromissos retroativos para os períodos abertos.',
        retroactiveDecisionTotal: '+ {{amount}}',
        retroactiveDecisionClosedPeriods:
          '{{count}} período(s) fechado(s) não serão incluídos: {{periods}}.',
        budgetRequestPromptTitle: 'Solicitar aumento de orçamento?',
        budgetRequestPromptBody:
          'A recorrência foi salva, mas há períodos/linhas acima do limite. Deseja abrir solicitações de aumento de limite para os itens abaixo?',
        budgetRequestPromptConfirm: 'Solicitar aumento',
        budgetRequestPromptMatches: '{{count}} ocorrências exigem ajuste de orçamento.',
        budgetRequestPromptJustificationPlaceholder:
          'Descreva por que o aumento de limite é necessário para essa recorrência.',
        recurringUntil: 'Fim',
        totalInstallments: 'Total de parcelas',
        currencyCode: 'Moeda',
        currencyCodeAria: 'Moeda da conta recorrente',
        currencyChangeWarning:
          'Os valores já cadastrados não são convertidos: eles passam a ser lidos nesta moeda. As contas já geradas mantêm a moeda original.',
        draftCurrencyUnsupported:
          'O contrato está em {{currency}}, moeda não suportada. O valor extraído foi descartado: informe o valor na moeda escolhida.',
        draftCurrencyMismatch:
          'A moeda do contrato ({{currency}}) difere da moeda da entidade ({{entityCurrency}}). O valor extraído foi descartado: informe o valor manualmente.',
        draftCurrencyUnresolved:
          'Não foi possível determinar a moeda da entidade; o valor do contrato foi descartado.',
        periodLimitAmount: 'Limite por período (orçamento)',
        periodLimitAmountTooltip:
          'Teto reservado no orçamento para cada período da recorrência. Separado do valor esperado.',
        periodLimitAmountTooltipAria: 'Ajuda: limite por período',
        classification: 'Classificação contábil',
        classificationHelp:
          'Define onde o compromisso de orçamento será registrado em cada período.',
        classificationRequired: 'A classificação contábil é obrigatória.',
        glAccount: 'Conta contábil (GL)',
        managerialAccount: 'Conta gerencial',
        costCenter: 'Centro de custo',
        department: 'Departamento',
        selectPlaceholder: 'Selecione',
        selectEntityFirst: 'Selecione a entidade antes de definir a classificação.',
        commitmentPreview:
          'Prévia de compromisso: {{count}} períodos × {{periodAmount}} = {{total}} reservados',
        commitmentPreviewOpenEnded:
          'Cada período reservará até {{periodAmount}} no orçamento (defina a data final para ver o total).',
      },
      frequency: {
        WEEKLY: 'Semanal',
        MONTHLY: 'Mensal',
        BIMONTHLY: 'Bimestral',
        QUARTERLY: 'Trimestral',
        SEMESTERLY: 'Semestral',
        YEARLY: 'Anual',
      },
      status: {
        ACTIVE: 'Ativo',
        INACTIVE: 'Inativo',
      },
      recurringBillType: {
        STANDARD: 'Padrão',
        PAYROLL: 'Folha de pagamento',
      },
      linkedToPosition: 'Vinculado: {{position}}',
      toast: {
        createSuccess: 'Conta recorrente criada com sucesso',
        createError: 'Não foi possível criar a conta recorrente',
        useExistingAction: 'Usar a existente',
        reactivateExistingAction: 'Reativar a existente',
        updateSuccess: 'Conta recorrente atualizada com sucesso',
        updateError: 'Não foi possível atualizar a conta recorrente',
        deactivateSuccess: 'Template inativado com sucesso',
        reactivateSuccess: 'Template reativado com sucesso',
        validationError: 'Preencha os campos obrigatórios do formulário.',
        nameRequired: 'Informe o nome da recorrência.',
        entityRequired: 'Selecione a entidade para continuar.',
        amountRequired: 'Informe o valor recorrente esperado.',
        periodLimitRequired: 'Informe o limite por período (orçamento).',
        budgetBlock: 'Os compromissos desta recorrência excedem o orçamento disponível.',
        budgetException:
          'Os compromissos desta recorrência exigem exceção de orçamento na aprovação.',
        budgetWarn: 'Os compromissos desta recorrência estão próximos ou acima do limite.',
        retroactiveBackfillApplied:
          'Compromissos retroativos incluídos para os períodos: {{periods}}.',
        retroactiveBackfillSkippedClosed:
          'Períodos retroativos fechados/bloqueados foram ignorados: {{periods}}.',
        budgetRequestCreated: 'Solicitações de aumento de orçamento criadas com sucesso.',
        budgetRequestCreatePartial:
          '{{createdCount}} solicitação(ões) criada(s) e {{failedCount}} falha(s). Revise e tente novamente.',
        budgetRequestCreateError: 'Não foi possível criar as solicitações de aumento de orçamento.',
        budgetRequestJustificationRequired:
          'Informe uma justificativa para criar a solicitação de aumento de orçamento.',
        budgetGateFailed: 'A verificação de orçamento falhou. A recorrência não foi salva.',
        budgetSyncFailed:
          'A recorrência foi salva, mas os compromissos de orçamento não foram sincronizados.',
        classificationSyncApplied:
          'Classificação sincronizada em {{count}} conta(s) em pré-aprovação vinculada(s).',
      },
      merge: {
        action: 'Combinar',
        title: 'Combinar recorrências',
        description: 'Selecione os templates que serão combinados em um único template.',
        keepLabel: 'Template que será mantido',
        keepPlaceholder: 'Selecione o template principal',
        sourcesLabel: 'Templates para combinar',
        noCandidates: 'Não há templates disponíveis para combinar.',
        continue: 'Continuar',
        confirm: 'Confirmar combinação',
        confirmMessage:
          'Esta ação moverá as contas vinculadas para o template mantido e inativará os templates selecionados ({{count}}).',
        selectedCount: '{{count}} selecionados',
        clearSelectionAria: 'Limpar seleção de templates',
        selectTemplateAria: 'Selecionar template {{name}} para combinação',
        toast: {
          success: 'Recorrências combinadas com sucesso',
          error: 'Não foi possível combinar as recorrências',
        },
      },
      cardUntil: 'Até: {{date}}',
      cardInstallments: 'Parcelas: {{count}}',
      cardPeriodLimit: 'Limite/período: {{amount}}',
      origin: 'Origem',
      originContract: 'Origem',
    },
    vendorDetail: {
      pageTabs: {
        overview: 'Visão geral',
        bills: 'Contas a pagar',
        recurring: 'Recorrências',
        paymentMethods: 'Métodos de pagamento',
        contacts: 'Contatos',
        documents: 'Documentos',
        fiscal: 'Contábil e fiscal',
        knowledge: 'Regras',
        mergeHistory: 'Histórico de mesclagem',
      },
      entity: {
        label: 'Entidade',
        placeholder: 'Selecione a entidade',
        hint: 'Contas a pagar, recorrências e regras mostram apenas a entidade escolhida. Os dados cadastrais do fornecedor valem para todas as entidades.',
        noEntities:
          'Nenhuma entidade disponível. Crie uma entidade para ver contas, recorrências e regras do fornecedor.',
      },
      code: 'Código {{code}}',
      fallbackTitle: 'Fornecedor',
      loadError: 'Não foi possível carregar o fornecedor.',
      edit: 'Editar',
      billsTab: {
        columns: {
          number: 'Número',
          description: 'Descrição',
          issueDate: 'Emissão',
          dueDate: 'Vencimento',
          amount: 'Valor',
          status: 'Status',
        },
        status: {
          DRAFT: 'Rascunho',
          SUBMITTED: 'Em revisão',
          PENDING_APPROVAL: 'Pendente de aprovação',
          APPROVED: 'Aprovado',
          REJECTED: 'Rejeitado',
          PARTIALLY_PAID: 'Parcialmente pago',
          PAID: 'Pago',
          COMPLETED: 'Concluído',
          VOID: 'Cancelado',
        },
        totalsLabel: 'Totais das contas',
        totalPaid: 'Total pago',
        totalOpen: 'Em aberto',
        requestedBy: 'Solicitado por {{name}}',
        actionsFor: 'Ações da conta {{number}}',
        openInNewTab: 'Abrir em nova aba',
        replicateClassifications: 'Replicar classificações',
        installment: 'Parcela {{number}}',
        emptyTitle: 'Nenhuma conta deste fornecedor',
      },
      confidentialDataRestricted:
        'Os dados pessoais, financeiros, fiscais e os documentos deste fornecedor estão protegidos.',
      tabs: {
        overview: 'Visão Geral',
        bills: 'Contas a pagar',
        recurring: 'Recorrência',
        paymentMethods: 'Métodos de pagamento',
        contacts: 'Contatos',
        fiscal: 'Contábil & Fiscal',
        documents: 'Documentos',
      },
      payment: {
        bankLabel: 'Banco',
        bankSearchPlaceholder: 'Buscar por nome ou código...',
        proposedEmployeeLinked:
          'Este fornecedor está ligado a um funcionário: os métodos de pagamento ficam no cadastro do funcionário.',
        title: 'Métodos de pagamento',
        subtitle: 'Contas no Brasil e nos EUA usadas para pagar este fornecedor.',
        addMethod: 'Adicionar método',
        empty: 'Nenhum método de pagamento cadastrado.',
        defaultBr: 'Padrão (Brasil)',
        defaultUs: 'Padrão (EUA)',
        verifiedBadge: 'Verificado',
        unverifiedBadge: 'Não verificado',
        registeredAtGateway: 'Registrado no gateway de pagamento',
        pixKeyType: 'Tipo de chave',
        pixKey: 'Chave PIX',
        bank: 'Banco',
        agencyAccount: 'Agência/Conta',
        accountKind: 'Tipo',
        accountKindValue: 'Conta {{type}}',
        verifiedOn: 'Verificado em {{date}}',
        verifiedBy: 'por {{name}} ({{email}})',
        verificationNote: 'Observação: {{note}}',
        menuLabel: 'Ações da conta {{account}}',
        edit: 'Editar',
        setDefaultBr: 'Definir como padrão no Brasil',
        setDefaultUs: 'Definir como padrão nos EUA',
        deactivate: 'Desativar',
        deactivateBlockedDefault: 'Defina outra conta como padrão antes de desativar esta.',
        verify: 'Verificar',
        verifyOnlyApprovers: 'Apenas aprovadores globais podem verificar.',
        verifyDialogTitle: 'Verificar método de pagamento',
        verifyDialogDescription: 'Informe uma observação para registrar a verificação.',
        verifyObservation: 'Observação',
        verifyObservationPlaceholder: 'Ex.: verificado por contato com o banco',
        verifyConfirm: 'Confirmar verificação',
        verifying: 'Verificando...',
        cancel: 'Cancelar',
        deactivateDialogTitle: 'Desativar esta conta?',
        deactivateDialogDescription:
          'A conta {{account}} deixa de aparecer na lista e não será mais usada em novos pagamentos.',
        deactivateConfirm: 'Desativar conta',
        deactivateError: 'Não foi possível desativar a conta. Tente novamente.',
        accountSummaryPix: 'PIX {{key}}',
        accountSummaryUs: 'ACH {{account}}',
        accountSummaryBr: '{{bank}} {{agency}}/{{account}}',
        toast: {
          verified: 'Método de pagamento verificado.',
          verifyError: 'Não foi possível verificar o método de pagamento. Tente novamente.',
          defaultSet: 'Conta definida como padrão.',
          defaultError: 'Não foi possível definir a conta como padrão. Tente novamente.',
          created: 'Conta bancária adicionada.',
          createError: 'Não foi possível adicionar a conta bancária. Tente novamente.',
          updated: 'Conta bancária atualizada.',
          updateError: 'Não foi possível atualizar a conta bancária. Tente novamente.',
          deactivated: 'Conta desativada.',
        },
      },
      bills: {
        replicateClassifications: {
          action: 'Replicar classificações',
          dialogTitle: 'Replicar classificações',
          dialogDescription:
            'Copie as classificações aplicadas desta conta para outras contas em pré-aprovação do mesmo fornecedor.',
          loadingCandidates: 'Carregando contas elegíveis...',
          noCandidates:
            'Nenhuma outra conta em pré-aprovação está disponível para receber essas classificações.',
          candidatesLabel: 'Contas elegíveis',
          selectedCount: '{{count}} contas selecionadas',
          sourceBillLabel: 'Conta de origem',
          targetBillLabel: 'Conta destino',
          amountLabel: 'Valor',
          issueDateLabel: 'Emissão',
          dueDateLabel: 'Vencimento',
          statusLabel: 'Status',
          clearSelection: 'Limpar seleção',
          cancel: 'Cancelar',
          confirm: 'Replicar classificações',
          replicating: 'Replicando...',
          success: 'Classificações replicadas em {{count}} contas.',
          partialSuccess:
            'Replicação concluída com ressalvas: {{succeeded}} sucesso(s), {{failed}} falha(s).',
          genericError: 'Não foi possível replicar as classificações.',
        },
      },
      balance: {
        kpiTitle: 'Saldo a receber (adiantamento)',
        kpiHint: 'Clique para ver o histórico',
        viewHistory: 'Ver histórico do saldo',
        adjust: 'Ajustar saldo',
        historyTitle: 'Histórico de saldo',
        historyDescription: 'Movimentos do adiantamento em ordem cronológica reversa.',
        loading: 'Carregando saldo...',
        loadError: 'Não foi possível carregar o saldo',
        historyLoadError: 'Não foi possível carregar o histórico',
        emptyHistory: 'Nenhum lançamento de saldo ainda.',
        table: {
          date: 'Data',
          description: 'Descrição',
          source: 'Origem',
          movement: 'Movimento',
          balance: 'Saldo',
        },
        sourceTypes: {
          RECONCILIATION: 'Conciliação',
          BILL_PROVISION: 'Conta a pagar',
          MANUAL_ADJUSTMENT: 'Ajuste manual',
          REVERSAL: 'Estorno',
        },
        glPendingBadge: 'Contabilização pendente',
        glPendingBadgeTooltip:
          'Este lançamento ainda não foi contabilizado no livro. A contabilização ocorrerá quando a conta for aprovada ou na próxima tentativa de reprocessamento.',
        adjustmentDialog: {
          title: 'Ajustar saldo (adiantamento)',
          description: 'Registre um crédito ou débito no saldo de adiantamento do fornecedor.',
          entity: 'Entidade',
          entityPlaceholder: 'Selecione a entidade',
          type: 'Tipo',
          credit: 'Crédito (aumentar saldo)',
          debit: 'Débito (reduzir saldo)',
          amount: 'Valor',
          reason: 'Motivo',
          reasonPlaceholder: 'Descreva o motivo do ajuste (obrigatório)',
          effectiveDate: 'Data efetiva',
          contraAccount: 'Conta contábil de contrapartida',
          contraPlaceholder: 'Selecione a conta GL',
          zeroBalance: 'Zerar saldo',
          submit: 'Confirmar ajuste',
          submitting: 'Salvando...',
          cancel: 'Cancelar',
          success: 'Saldo ajustado com sucesso',
          error: 'Não foi possível aplicar o ajuste',
          liveBalanceError: 'Não foi possível consultar o saldo atual. Tente novamente.',
          debitAboveBalance: {
            message:
              'O saldo atual de {{entity}} é {{balance}}. Este débito de {{amount}} deixa o saldo em {{result}}. Confirmar?',
            confirm: 'Confirmar débito',
            back: 'Voltar',
            refused: 'O saldo mudou e não cobre mais este débito. Salve de novo para rever.',
          },
          validation: {
            entityRequired: 'Selecione a entidade do ajuste.',
            reasonRequired: 'Informe o motivo do ajuste.',
            amountInvalid: 'Informe um valor válido maior que zero.',
            contraRequired: 'Selecione a conta contábil de contrapartida.',
          },
        },
      },
      stats: {
        totalPaid12m: 'Total Pago (12m)',
        totalPaid: 'Total pago',
        openBills: 'Contas em Aberto',
        openBillsCount: '{{count}} contas',
        lastTransaction: 'Última Transação',
        daysAgo: '{{count}} dias atrás',
        notAvailable: 'N/A',
      },
      mergeHistory: {
        tabTitle: 'Histórico de mesclagem',
        description:
          'Registros em que este fornecedor absorveu outro e as contas foram reatribuídas.',
        loading: 'Carregando...',
        loadError: 'Não foi possível carregar o histórico de mesclagem.',
        table: {
          date: 'Data',
          user: 'Usuário',
          sourceName: 'Nome (origem)',
          sourceCode: 'Código',
          sourceTaxId: 'CPF/CNPJ',
          bills: 'Contas reatribuídas',
        },
        snapshotNote: 'Valores conforme o fornecedor de origem no momento da mesclagem.',
      },
    },
    vendorDocuments: {
      title: 'Documentos do Fornecedor',
      addButton: 'Adicionar Documento',
      noDocuments: 'Nenhum documento cadastrado.',
      saveFirst: 'Salve o fornecedor primeiro para adicionar documentos.',
      loading: 'Carregando documentos...',
      loadError: 'Não foi possível carregar os documentos.',
      loadErrorDescription: 'Verifique sua conexão e tente novamente.',
      subtitle: 'Documentos e contratos do fornecedor',
      uploadContractHint:
        'Anexe contratos, certidões ou comprovantes. Contratos são analisados por IA para pré-preencher contas recorrentes.',
      dialogDescription:
        'Faça o upload do documento. Contratos são processados automaticamente para sugerir contas recorrentes.',
      retry: 'Tentar novamente',
      table: {
        type: 'Tipo',
        name: 'Nome',
        number: 'Número',
        issueDate: 'Emissão',
        expiryDate: 'Validade',
        status: 'Status',
        verified: 'Verificado',
        actions: 'Ações',
      },
      status: {
        valid: 'Válido',
        expired: 'Expirado',
        pendingRenewal: 'Renovação Pendente',
        rejected: 'Rejeitado',
      },
      dialog: {
        add: 'Adicionar Documento',
        edit: 'Editar Documento',
      },
      confirmations: {
        delete: 'Deseja realmente excluir este documento?',
      },
      form: {
        entity: {
          label: 'Entidade *',
          placeholder: 'Selecione a entidade',
          required: 'Selecione a entidade do documento',
        },
        file: {
          label: 'Arquivo *',
          description: 'Formatos aceitos: PDF, PNG, JPG, JPEG (máximo 10MB)',
        },
        fileTooLarge: 'O arquivo excede o limite máximo de 10MB',
        fileRequired: 'Selecione um arquivo para upload',
        documentType: {
          label: 'Tipo de Documento *',
          placeholder: 'Selecione um tipo',
          loading: 'Carregando...',
          noTypes: 'Nenhum tipo de documento disponível',
        },
        documentName: {
          label: 'Nome do Documento',
          placeholder: 'Ex: Contrato de Prestação de Serviços',
        },
        documentNumber: {
          label: 'Número do Documento',
          placeholder: 'Ex: CTR-2026-001',
        },
        issueDate: {
          label: 'Data de Emissão',
        },
        expiryDate: {
          label: 'Data de Validade',
        },
        issuingAuthority: {
          label: 'Órgão Emissor',
        },
        verificationCode: {
          label: 'Código de Verificação',
        },
        status: {
          label: 'Status',
        },
        notes: {
          label: 'Observações',
          placeholder: 'Observações adicionais...',
        },
        submit: {
          add: 'Adicionar',
          update: 'Atualizar',
          saving: 'Salvando...',
        },
      },
      actions: {
        extract: 'Extrair conta recorrente',
        extractShort: 'Recorrência',
        view: 'Visualizar',
        download: 'Baixar',
        delete: 'Excluir',
      },
      contractExtraction: {
        extracting: 'Processando contrato com IA...',
        extractSuccess: 'Dados do contrato extraídos. Revise os campos e salve a conta recorrente.',
        extractFailed:
          'Não foi possível extrair dados automaticamente do contrato. O arquivo foi anexado com sucesso.',
      },
      toasts: {
        documentNotAvailable: 'Documento indisponível para visualização',
        documentError: 'Não foi possível carregar o documento',
        uploadSuccess: 'Documento anexado com sucesso.',
        uploadError: 'Erro ao anexar documento.',
        duplicateDocument: 'Este arquivo já foi anexado para esta entidade.',
        deleteSuccess: 'Documento excluído com sucesso.',
        deleteError: 'Erro ao excluir documento.',
      },
    },
  },
} as const;

export const vendorsEn = {
  common: {
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    add: 'Add',
    create: 'Create',
    update: 'Update',
    back: 'Back',
    actions: 'Actions',
    search: 'Search',
    noResults: 'No results found',
    download: 'Download',
  },
  selector: {
    label: 'Vendor',
    placeholder: 'Select a vendor',
    emptyMessage: 'No vendors available.',
    notFoundMessage: 'No vendors found.',
    searchError: 'Error searching vendors',
    removeVendorAria: 'Remove vendor',
    searchPlaceholder: 'Search by legal name, trade name, or document...',
    loading: 'Searching vendors...',
    createVendor: 'Create vendor "{{searchTerm}}"',
    resultsLabel: 'Vendors',
    selectedCount: '{{count}} selected',
    clearSelectionAria: 'Clear selection',
  },
  errors: {
    loadVendors: 'Failed to load vendors',
    loadVendor: 'Failed to load vendor',
    createVendor: 'Failed to create vendor',
    duplicateCpf: 'A vendor with this CPF already exists',
    duplicateCnpj: 'A vendor with this CNPJ already exists',
    duplicateVendorCode: 'Vendor code already exists',
    internationalIdentityRequired: 'Enter the country and foreign tax ID to activate this vendor.',
    collaboratorEntityRequired: 'Select the collaborator entity to continue.',
    updateVendor: 'Failed to update vendor',
    deleteVendor: 'Failed to delete vendor',
    mergeVendors: 'Could not merge vendors',
    mergePreview: 'Could not load merge preview',
    inactivateVendor: 'Failed to inactivate vendor',
    loadMergeHistory: 'Failed to load merge history',
    loadDocuments: 'Failed to load documents',
    createDocument: 'Failed to create document',
    updateDocument: 'Failed to update document',
    deleteDocument: 'Failed to delete document',
    loadDocumentTypes: 'Failed to load document types',
    downloadUnavailable: 'Download URL not available',
    fileRequired: 'File is required for new documents',
    documentTypeRequired: 'Document type is required',
    loadDuplicates: 'Failed to load potential duplicates',
    dismissDuplicate: 'Could not dismiss.',
  },
  success: {
    vendorCreated: 'Vendor created successfully',
    vendorUpdated: 'Vendor updated successfully',
    vendorInactivated: 'Vendor inactivated successfully',
    vendorsMerged: 'Vendors merged successfully',
    documentCreated: 'Document created successfully',
    documentUpdated: 'Document updated successfully',
    documentDeleted: 'Document deleted successfully',
  },
  pages: {
    vendors: {
      title: 'Vendors',
      createButton: 'Create vendor',
      searchPlaceholder: 'Search by name, CPF/CNPJ, email...',
      listing: {
        subtitle: "The company's suppliers and service providers",
        create: 'New vendor',
        moreActions: 'More actions',
        views: 'Vendor status',
        viewAll: 'All',
        duplicates: 'Possible duplicates',
        status: {
          ACTIVE: 'Active',
          INACTIVE: 'Inactive',
          BLOCKED: 'Blocked',
          UNDER_REVIEW: 'Under review',
        },
        statusBadge: {
          ACTIVE: 'Active',
          INACTIVE: 'Inactive',
          BLOCKED: 'Blocked',
          UNDER_REVIEW: 'Under review',
        },
        columns: {
          name: 'Name',
          taxIdType: 'Type',
          document: 'CPF/CNPJ',
          vendorType: 'Vendor type',
          establishment: 'Establishment',
          email: 'Email',
          phone: 'Phone',
          status: 'Status',
        },
        taxIdType: {
          CNPJ: 'Company',
          CPF: 'Individual',
          ACRONYM: 'Acronym',
          INTERNATIONAL: 'Foreign',
          RFC: 'Foreign (RFC)',
          EIN: 'Foreign (EIN)',
        },
        vendorType: {
          SUPPLIER: 'Supplier',
          SERVICE_PROVIDER: 'Service provider',
          BOTH: 'Supplier and provider',
          GOVERNMENT_ENTITY: 'Government entity',
          BANK_FEE: 'Bank fee',
        },
        establishment: {
          HEADQUARTERS: 'Headquarters',
          BRANCH: 'Branch',
          NONE: 'Not provided',
        },
        collaboratorFilter: {
          label: 'Collaborators',
          only: 'Collaborators only',
          exclude: 'Exclude collaborators',
        },
        collaborator: 'Collaborator',
        invalidTaxId: 'Invalid {{type}}',
        searchLabel: 'Search vendors',
        searchPlaceholder: 'Name, CPF/CNPJ or email',
        actionsFor: 'Actions for {{name}}',
        edit: 'Edit',
        inactivate: 'Inactivate',
        merge: 'Merge',
        mergeHint: 'Select two or more vendors to merge',
        nounOne: 'vendor',
        nounOther: 'vendors',
        emptyTitle: 'No vendors yet',
        emptyDescription: 'Add the first vendor to record bills.',
        inactivateTitle: 'Inactivate vendor',
        inactivateDescription: '{{name}} will no longer be offered on new bills.',
        inactivateConfirm: 'Inactivate',
        cancel: 'Cancel',
        inactivateError: 'The vendor could not be inactivated. Try again.',
        inactivated: 'Vendor inactivated',
        exportError: 'The bank accounts could not be exported. Try again.',
      },
      filters: {
        title: 'Filters',
        taxIdType: {
          label: 'Type',
          all: 'All',
          cpf: 'CPF',
          cnpj: 'CNPJ',
        },
        status: {
          label: 'Status',
          all: 'All',
          active: 'Active',
          inactive: 'Inactive',
          blocked: 'Blocked',
          underReview: 'Under Review',
        },
        vendorType: {
          label: 'Vendor Type',
          all: 'All',
          supplier: 'Supplier',
          serviceProvider: 'Service Provider',
          both: 'Both',
        },
      },
      establishmentType: {
        label: 'Establishment Type',
        short: 'Estab. Type',
        HEADQUARTERS: 'Headquarters',
        BRANCH: 'Branch',
      },
      unifyGroupAccounts: {
        label: 'Unify corporate group accounts',
        description:
          'When active, accounts from all CNPJs in the same corporate group are considered for classification',
      },
      fiscalTab: {
        emptyTitle: 'Nothing to configure here',
        emptyDescription:
          'The corporate group only exists for vendors with a CNPJ. The fiscal classification and the vendor rules are on the Rules tab.',
      },
      collaborator: {
        label: 'Collaborator',
        badge: 'Collaborator',
        filterLabel: 'Classification',
        filterAll: 'All vendors',
        filterOnly: 'Collaborators only',
        filterExclude: 'Exclude collaborators',
        description:
          'Mark employee or contractor vendors who act as collaborators. This does not automatically add the person to payroll.',
        entityLabel: 'Collaborator entity',
        entityPlaceholder: 'Select an entity',
        effect:
          'While collaborator-data protection is active, this vendor’s amounts, documents and ledger entries are visible only to people with access to collaborator data.',
      },
      table: {
        name: 'Name',
        type: 'Type',
        establishmentType: 'Estab. Type',
        document: 'CPF/CNPJ',
        email: 'Email',
        phone: 'Phone',
        status: 'Status',
        select: 'Select',
        actions: 'Actions',
        noVendors: 'No vendors found.',
      },
      mergeWizard: {
        mergeButton: 'Merge vendors',
        selectVendorsTooltip: 'Select two or more vendors to merge',
        dialogTitle: 'Merge vendors',
        step1: 'Target',
        step2: 'Conflicts',
        step3: 'Confirm',
        targetHint: 'Choose the vendor record that will remain after the merge.',
        targetIneligible: 'A {{status}} record cannot absorb a merge.',
        noEligibleTargetAlert:
          'None of the selected vendors can absorb the merge. Reactivate or unblock the record that should remain and try again.',
        targetUnderReview: 'This record is under review and stays that way after the merge.',
        activateTarget: 'Activate this record when the merge completes',
        sourceBlocked: 'Cannot be merged into another record: {{reasons}}.',
        sourceBlockedHint: 'Make it the target, or resolve those links before merging.',
        blockerReasons: {
          BANK_FEE_CONFIGURATION: 'it is linked to bank fee configuration',
          REIMBURSEMENT_REQUESTER: 'it is a reimbursement requester',
          PCC_ACCUMULATOR: 'it has PCC accumulator history',
        },
        legalName: 'Legal name',
        tradeName: 'Trade name',
        document: 'Tax ID',
        vendorCode: 'Code',
        status: 'Status',
        billCount: 'Bills',
        totalBilled: 'Total billed',
        next: 'Next',
        back: 'Back',
        cancel: 'Cancel',
        loadingPreview: 'Loading data…',
        tradeNamePick: 'Trade name (conflicting values)',
        fromVendor: 'Use from: {{name}}',
        contactsPick: 'Contacts',
        primaryBlock: 'Primary contact',
        financialBlock: 'Financial contact',
        bankAccounts: 'Bank accounts',
        keepAccount: 'Keep',
        addressPrimary: 'Primary address',
        addressLine: '{{street}}, {{number}} — {{city}}/{{state}}',
        confirmIntro: 'Summary',
        confirmBills_one: '{{count}} bill will be reassigned to {{name}}',
        confirmBills_other: '{{count}} bills will be reassigned to {{name}}',
        confirmBillsAmount: 'Historical total: {{amount}}',
        confirmBanks_one: '{{count}} bank account will be consolidated on the surviving record',
        confirmBanks_other: '{{count}} bank accounts will be consolidated on the surviving record',
        confirmDeactivate_one: '{{count}} record will be deactivated',
        confirmDeactivate_other: '{{count}} records will be deactivated',
        confirmGl: 'GL journal entries will NOT be modified.',
        confirmTargetStays: 'The surviving record stays {{status}}.',
        confirmTargetActivates: 'The surviving record will go from under review to active.',
        confirmTaxIdDiverges:
          'The selected tax IDs differ. The merge asserts these records are the same person and moves the tax identifiers onto the surviving record. Confirm that is what you mean before continuing.',
        confirmWarning: 'This operation cannot be undone in the system.',
        confirmButton: 'Confirm merge',
        merging: 'Merging…',
        resultBills_one: '{{count}} bill reassigned',
        resultBills_other: '{{count}} bills reassigned',
        resultBanks_one: '{{count}} bank account consolidated',
        resultBanks_other: '{{count}} bank accounts consolidated',
        resultDeactivated_one: '{{count}} record deactivated',
        resultDeactivated_other: '{{count}} records deactivated',
        successWarnings_one:
          '{{count}} item could not be consolidated. Review the surviving record.',
        successWarnings_other:
          '{{count}} items could not be consolidated. Review the surviving record.',
        resultTitle: 'Merge complete',
        resultActivated: 'The surviving record was activated.',
        resultDone: 'Done',
        noPreview: 'Could not load the summary. Please try again.',
        validation: {
          pickTarget: 'Select the target vendor.',
          noEligibleTarget:
            'No selected vendor can absorb the merge (only Active and Under review).',
          sourceBlocked:
            '{{name}} cannot be merged into another record. Make it the target, or resolve those links first.',
          keepOneBank: 'Keep at least one bank account.',
          pickPrimary: 'Select a primary address.',
          duplicateBank:
            'Duplicate bank accounts (bank/agency/account number) in your selection. Adjust before continuing.',
        },
      },
      confirmations: {
        inactivate: 'Inactivate vendor {{name}}?\nThis action can be reversed in the future.',
      },
      duplicates: {
        tab: 'Potential duplicates',
        badge: '{{count}} duplicate groups',
        alert: '{{count}} potential duplicate group(s) found.',
        reviewButton: 'Review potential duplicates',
        viewAll: 'View all',
        empty: 'No duplicate groups found.',
        taxId: 'Tax ID',
        similarity: 'similarity',
        expandHint_one: '{{count}} vendor',
        expandHint_other: '{{count}} vendors',
        reviewMerge: 'Review & merge',
        dismiss: 'Dismiss',
        dismissToast: 'Group dismissed.',
        table: {
          code: 'Code',
          name: 'Name',
          status: 'Status',
          bills: 'Bills',
        },
        wizard: {
          title: 'Merge vendors',
          description:
            'Other records in this group will be inactivated; bills, addresses, and related data move to the vendor you keep.',
          targetLabel: 'Keep this vendor',
          targetIneligible: 'Cannot absorb a merge.',
          blockedSources_one:
            'Cannot merge: {{details}}. Make it the target, or resolve those links first.',
          blockedSources_other:
            'Cannot merge: {{details}}. Make one of them the target, or resolve those links first.',
          cancel: 'Cancel',
          confirm: 'Merge',
          merging: 'Merging...',
        },
      },
    },
    vendorForm: {
      create: {
        title: 'New Vendor',
        description: 'Fill in the data to create a new vendor',
      },
      edit: {
        title: 'Edit Vendor',
        description: 'Update vendor information',
      },
      tabs: {
        basic: 'Basic Information',
        tax: 'Tax Data',
        contact: 'Contacts',
        payment: 'Payment',
        withholdings: 'Withholdings',
        fiscal: 'Fiscal Classification',
        additional: 'Additional',
        addresses: 'Addresses',
        bankAccounts: 'Bank Accounts',
        documents: 'Documents',
      },
      saveButton: 'Save',
      cancelButton: 'Cancel',
      saving: 'Saving...',
      foreignTaxId: 'Foreign tax ID',
      foreignTaxIdPlaceholder: 'E.g. 12-3456789',
      country: 'Country',
      countryPlaceholder: 'Select a country',
      foreignTaxRegime: 'Foreign',
    },
    recurringBills: {
      tabTitle: 'Recurring',
      emptyState: 'No recurring bill template found',
      createNew: 'Create new recurrence',
      edit: 'Edit',
      deactivate: 'Deactivate',
      reactivate: 'Reactivate',
      editDialogTitle: 'Edit recurring bill',
      createDialogTitle: 'Create recurring bill',
      createFromBillDialogTitle: 'Create recurring bill from this bill',
      editDialogDescription: 'Change the name and terms of the recurring bill.',
      form: {
        name: 'Name',
        namePlaceholder: 'E.g. Mobile phone bill',
        description: 'Description',
        descriptionPlaceholder: 'Detailed description (optional)',
        addDescription: 'Add description',
        createdAt: 'created on {{date}}',
        statusActive: 'Active',
        statusPaused: 'Paused',
        tabs: {
          recurrence: 'Recurrence',
          classification: 'Classification',
          linkedBills: 'Linked bills',
        },
        continueTo: 'Continue: {{tab}}',
        requiredPending: '{{count}} required field(s) in {{tab}}',
        openEndedSummary: 'Without an end date, the reservation is indefinite.',
        summary: {
          frequency: 'Frequency',
          firstPeriod: 'First period',
          periods: 'Periods',
          totalReserved: 'Total reserved',
          day: 'day {{day}}',
          indefinite: 'Indefinite',
          hasEnd: 'with an end date',
          noEnd: 'without an end date',
          withRetroactive: 'includes prior periods',
          withoutRetroactive: 'without prior periods',
          perPeriod: '{{amount}} per period',
        },
        linkedBillsHelp:
          'Bills that already used this template and how much of each period’s reserved budget they consumed.',
        linkedBillsPeriod: 'Period',
        linkedBillsBill: 'Bill',
        linkedBillsReserved: 'Reserved',
        linkedBillsRealized: 'Realized',
        linkedBillsEmpty: 'No linked bill or projected period yet.',
        linkedBillsAwaiting: 'Awaiting bill',
        linkedBillsProjectedStatus: 'Projected',
        amount: 'Expected recurring amount',
        amountVariable: 'Expected average recurring amount',
        amountTooltip: 'The contracted/expected value for each bill in this recurrence',
        amountTooltipVariable: 'Expected average value for each bill when recurrence is variable',
        amountTooltipAria: 'Help: expected recurring amount',
        amountTooltipVariableAria: 'Help: expected average recurring amount',
        recurrenceType: 'Recurrence type',
        recurrenceTypeFixedTitle: 'Fixed',
        recurrenceTypeFixedDescription: 'Contracted value. Variation compares against expected.',
        recurrenceTypeVariableTitle: 'Variable',
        recurrenceTypeVariableDescription:
          'Value changes. Variation compares against recent average.',
        variableComparisonMonths: 'Calc. variation based on last:',
        variableComparisonMonthsTooltip:
          'The system uses this number of months to compare variation for each bill',
        variableComparisonMonthsTooltipAria: 'Help: months used for variation comparison',
        recurringBillType: 'Recurrence nature',
        recurringBillTypeHelp:
          'Payroll recurrences are visible only to principals cleared for payroll data.',
        naturezaChangeConfirmTitle: 'Change this template’s Natureza?',
        naturezaChangeConfirmBody:
          'Changing Natureza reclassifies how this contract’s history appears in FP&A reports (payroll vs. recurring/residual), including already-closed periods. If you do not want to reclassify past months, end this recurring bill instead and create a new one with the correct Natureza.',
        naturezaChangeConfirmConfirm: 'Change Natureza anyway',
        headcountPosition: 'Link to a Hiring Plan position',
        headcountPositionNone: 'None',
        headcountPositionHint:
          'Only still-Planned PJ positions of this entity appear. Linking hires the position on save.',
        entity: 'Entity',
        entityPlaceholder: 'Select an entity',
        payrollFrequencyHint: 'Payroll recurrences are always monthly.',
        frequency: 'Frequency',
        status: 'Status',
        paymentTermDays: 'Days until payment',
        paymentTermAutomatic: 'Automatic',
        paymentTermDaysHelp:
          'D+X calendar days from competency for cash projections. Leave empty to use recurring payment history, then the entity calendar or competency date. Scheduled payments and documentary due dates take precedence.',
        expectedDueDayOfMonth: 'Expected due day',
        expectedDueDayOfMonthPlaceholder: 'E.g. 10',
        expectedCompetencyDayOfMonth: 'Expected competency day',
        expectedCompetencyDayOfMonthPlaceholder: 'E.g. 5',
        recurringSince: 'Start',
        recurringSinceHelp:
          'Optional. When empty, the system uses template creation date as the start.',
        recurringUntilHelp: 'Leave empty for an indefinite end date',
        retroactiveConfirmTitle: 'Create retroactive commitments?',
        retroactiveConfirmBody:
          'Since the recurrence starts in a period before the current one, do you want to create budget commitments for retroactive periods?',
        retroactiveConfirmOpenLabel: 'Will be backfilled (open periods): {{periods}}',
        retroactiveConfirmClosedLabel:
          'The following periods will be skipped because they are closed:',
        retroactiveConfirmFallback:
          'Could not pre-load period statuses. If you confirm, the system will only include open past periods.',
        createWithoutBackfill: 'Reserve current/future budget only',
        createWithBackfill: 'Reserve retroactive budget',
        retroactiveDecisionTitle: 'The start date includes {{count}} prior periods',
        retroactiveDecisionDescription: 'Choose how the budget should treat those prior periods.',
        retroactiveDecisionCurrentFutureTitle: 'Do not reserve prior periods',
        retroactiveDecisionCurrentFutureDescription:
          'Prior periods remain without commitments. Bills already recorded in them will not change.',
        retroactiveDecisionIncludeTitle: 'Include {{count}} open prior periods',
        retroactiveDecisionIncludeDescription:
          'Creates retroactive commitments for the open periods.',
        retroactiveDecisionTotal: '+ {{amount}}',
        retroactiveDecisionClosedPeriods:
          '{{count}} closed period(s) will not be included: {{periods}}.',
        budgetRequestPromptTitle: 'Request budget increase?',
        budgetRequestPromptBody:
          'The recurring template was saved, but some periods/lines are over budget. Do you want to open budget increase requests for the items below?',
        budgetRequestPromptConfirm: 'Request increase',
        budgetRequestPromptMatches: '{{count}} occurrences require a budget adjustment.',
        budgetRequestPromptJustificationPlaceholder:
          'Describe why the budget increase is required for this recurring template.',
        recurringUntil: 'End',
        totalInstallments: 'Total installments',
        currencyCode: 'Currency',
        currencyCodeAria: 'Recurring bill currency',
        currencyChangeWarning:
          'Existing amounts are not converted: they are simply reinterpreted in this currency. Bills already generated keep their original currency.',
        draftCurrencyUnsupported:
          'The contract is in {{currency}}, which is not supported. The extracted amount was discarded: enter the amount in the chosen currency.',
        draftCurrencyMismatch:
          'The contract currency ({{currency}}) differs from the entity currency ({{entityCurrency}}). The extracted amount was discarded: enter the amount manually.',
        draftCurrencyUnresolved:
          "The entity's currency could not be determined; the contract amount was discarded.",
        periodLimitAmount: 'Per-period limit (budget)',
        periodLimitAmountTooltip:
          'Budget ceiling reserved for each recurrence period. Separate from expected amount.',
        periodLimitAmountTooltipAria: 'Help: per-period limit',
        classification: 'Accounting classification',
        classificationHelp: 'Defines where the budget commitment is recorded each period.',
        classificationRequired: 'Accounting classification is required.',
        glAccount: 'GL account',
        managerialAccount: 'Managerial account',
        costCenter: 'Cost center',
        department: 'Department',
        selectPlaceholder: 'Select',
        selectEntityFirst: 'Select the entity before setting classification.',
        commitmentPreview:
          'Commitment preview: {{count}} periods × {{periodAmount}} = {{total}} reserved',
        commitmentPreviewOpenEnded:
          'Each period will reserve up to {{periodAmount}} in budget (set end date to see total).',
      },
      frequency: {
        WEEKLY: 'Weekly',
        MONTHLY: 'Monthly',
        BIMONTHLY: 'Bimonthly',
        QUARTERLY: 'Quarterly',
        SEMESTERLY: 'Semiannual',
        YEARLY: 'Yearly',
      },
      status: {
        ACTIVE: 'Active',
        INACTIVE: 'Inactive',
      },
      recurringBillType: {
        STANDARD: 'Standard',
        PAYROLL: 'Payroll',
      },
      linkedToPosition: 'Linked: {{position}}',
      toast: {
        createSuccess: 'Recurring bill created successfully',
        createError: 'Failed to create recurring bill',
        useExistingAction: 'Use the existing one',
        reactivateExistingAction: 'Reactivate the existing one',
        updateSuccess: 'Recurring bill updated successfully',
        updateError: 'Failed to update recurring bill',
        deactivateSuccess: 'Template deactivated successfully',
        reactivateSuccess: 'Template reactivated successfully',
        validationError: 'Fill in the required form fields.',
        nameRequired: 'Enter the recurring bill name.',
        entityRequired: 'Select an entity to continue.',
        amountRequired: 'Enter the expected recurring amount.',
        periodLimitRequired: 'Enter the per-period budget limit.',
        budgetBlock: 'This recurrence commitments exceed available budget.',
        budgetException: 'This recurrence commitments require a budget exception on approval.',
        budgetWarn: 'This recurrence commitments are near or above the budget limit.',
        retroactiveBackfillApplied:
          'Retroactive commitments were created for periods: {{periods}}.',
        retroactiveBackfillSkippedClosed:
          'Closed/locked retroactive periods were skipped: {{periods}}.',
        budgetRequestCreated: 'Budget increase requests created successfully.',
        budgetRequestCreatePartial:
          '{{createdCount}} request(s) created and {{failedCount}} failed. Review and try again.',
        budgetRequestCreateError: 'Could not create the budget increase requests.',
        budgetRequestJustificationRequired:
          'Provide a justification to create the budget increase request.',
        budgetGateFailed: 'Budget check failed. The recurring template was not saved.',
        budgetSyncFailed:
          'The recurring template was saved, but budget commitments were not synchronized.',
        classificationSyncApplied:
          'Classification synced to {{count}} linked pre-approval bill(s).',
      },
      merge: {
        action: 'Merge',
        title: 'Merge recurring templates',
        description: 'Select the templates that should be merged into one template.',
        keepLabel: 'Template to keep',
        keepPlaceholder: 'Select the primary template',
        sourcesLabel: 'Templates to merge',
        noCandidates: 'There are no templates available to merge.',
        continue: 'Continue',
        confirm: 'Confirm merge',
        confirmMessage:
          'This action will reassign linked bills to the kept template and deactivate selected templates ({{count}}).',
        selectedCount: '{{count}} selected',
        clearSelectionAria: 'Clear template selection',
        selectTemplateAria: 'Select template {{name}} for merge',
        toast: {
          success: 'Recurring templates merged successfully',
          error: 'Failed to merge recurring templates',
        },
      },
      cardUntil: 'Until: {{date}}',
      cardInstallments: 'Installments: {{count}}',
      cardPeriodLimit: 'Limit/period: {{amount}}',
      origin: 'Origin',
      originContract: 'Origin',
    },
    vendorDetail: {
      pageTabs: {
        overview: 'Overview',
        bills: 'Bills',
        recurring: 'Recurring bills',
        paymentMethods: 'Payment methods',
        contacts: 'Contacts',
        documents: 'Documents',
        fiscal: 'Accounting and tax',
        knowledge: 'Rules',
        mergeHistory: 'Merge history',
      },
      entity: {
        label: 'Entity',
        placeholder: 'Select the entity',
        hint: 'Bills, recurring bills and rules show only the chosen entity. The vendor registration data applies to every entity.',
        noEntities:
          'No entity available. Create an entity to see the vendor bills, recurring bills and rules.',
      },
      code: 'Code {{code}}',
      fallbackTitle: 'Vendor',
      loadError: 'The vendor could not be loaded.',
      edit: 'Edit',
      billsTab: {
        columns: {
          number: 'Number',
          description: 'Description',
          issueDate: 'Issued',
          dueDate: 'Due',
          amount: 'Amount',
          status: 'Status',
        },
        status: {
          DRAFT: 'Draft',
          SUBMITTED: 'In review',
          PENDING_APPROVAL: 'Pending approval',
          APPROVED: 'Approved',
          REJECTED: 'Rejected',
          PARTIALLY_PAID: 'Partially paid',
          PAID: 'Paid',
          COMPLETED: 'Completed',
          VOID: 'Cancelled',
        },
        totalsLabel: 'Bill totals',
        totalPaid: 'Total paid',
        totalOpen: 'Open',
        requestedBy: 'Requested by {{name}}',
        actionsFor: 'Actions for bill {{number}}',
        openInNewTab: 'Open in a new tab',
        replicateClassifications: 'Replicate classifications',
        installment: 'Installment {{number}}',
        emptyTitle: 'No bills for this vendor',
      },
      confidentialDataRestricted:
        "This vendor's personal, financial, tax, and document data is protected.",
      tabs: {
        overview: 'Overview',
        bills: 'Accounts payable',
        recurring: 'Recurring',
        paymentMethods: 'Payment methods',
        contacts: 'Contacts',
        fiscal: 'Accounting & Tax',
        documents: 'Documents',
      },
      payment: {
        bankLabel: 'Bank',
        bankSearchPlaceholder: 'Search by name or code...',
        proposedEmployeeLinked:
          "This vendor is linked to an employee: payment methods live on the employee's record.",
        title: 'Payment methods',
        subtitle: 'Brazilian and US accounts used to pay this vendor.',
        addMethod: 'Add method',
        empty: 'No payment method registered.',
        defaultBr: 'Default (Brazil)',
        defaultUs: 'Default (United States)',
        verifiedBadge: 'Verified',
        unverifiedBadge: 'Not verified',
        registeredAtGateway: 'Registered at the payment gateway',
        pixKeyType: 'Key type',
        pixKey: 'PIX key',
        bank: 'Bank',
        agencyAccount: 'Branch/Account',
        accountKind: 'Type',
        accountKindValue: '{{type}} account',
        verifiedOn: 'Verified on {{date}}',
        verifiedBy: 'by {{name}} ({{email}})',
        verificationNote: 'Note: {{note}}',
        menuLabel: 'Actions for account {{account}}',
        edit: 'Edit',
        setDefaultBr: 'Set as default in Brazil',
        setDefaultUs: 'Set as default in the United States',
        deactivate: 'Deactivate',
        deactivateBlockedDefault:
          'Set another account as the default before deactivating this one.',
        verify: 'Verify',
        verifyOnlyApprovers: 'Only global approvers can verify.',
        verifyDialogTitle: 'Verify payment method',
        verifyDialogDescription: 'Add a note to record the verification.',
        verifyObservation: 'Note',
        verifyObservationPlaceholder: 'E.g. verified by contacting the bank',
        verifyConfirm: 'Confirm verification',
        verifying: 'Verifying...',
        cancel: 'Cancel',
        deactivateDialogTitle: 'Deactivate this account?',
        deactivateDialogDescription:
          'Account {{account}} no longer appears in the list and will not be used for new payments.',
        deactivateConfirm: 'Deactivate account',
        deactivateError: 'Could not deactivate the account. Try again.',
        accountSummaryPix: 'PIX {{key}}',
        accountSummaryUs: 'ACH {{account}}',
        accountSummaryBr: '{{bank}} {{agency}}/{{account}}',
        toast: {
          verified: 'Payment method verified.',
          verifyError: 'Could not verify the payment method. Try again.',
          defaultSet: 'Account set as the default.',
          defaultError: 'Could not set the account as the default. Try again.',
          created: 'Bank account added.',
          createError: 'Could not add the bank account. Try again.',
          updated: 'Bank account updated.',
          updateError: 'Could not update the bank account. Try again.',
          deactivated: 'Account deactivated.',
        },
      },
      bills: {
        replicateClassifications: {
          action: 'Replicate classifications',
          dialogTitle: 'Replicate classifications',
          dialogDescription:
            'Copy the classifications applied to this bill to other pre-approval bills from the same vendor.',
          loadingCandidates: 'Loading eligible bills...',
          noCandidates:
            'No other pre-approval bill is currently available to receive these classifications.',
          candidatesLabel: 'Eligible bills',
          selectedCount: '{{count}} bills selected',
          sourceBillLabel: 'Source bill',
          targetBillLabel: 'Target bill',
          amountLabel: 'Amount',
          issueDateLabel: 'Issue date',
          dueDateLabel: 'Due date',
          statusLabel: 'Status',
          clearSelection: 'Clear selection',
          cancel: 'Cancel',
          confirm: 'Replicate classifications',
          replicating: 'Replicating...',
          success: 'Classifications replicated to {{count}} bills.',
          partialSuccess:
            'Replication completed with warnings: {{succeeded}} succeeded, {{failed}} failed.',
          genericError: 'Could not replicate classifications.',
        },
      },
      balance: {
        kpiTitle: 'Balance to receive (advance)',
        kpiHint: 'Click to view history',
        viewHistory: 'View balance history',
        adjust: 'Adjust balance',
        historyTitle: 'Balance history',
        historyDescription: 'Advance balance movements in reverse chronological order.',
        loading: 'Loading balance...',
        loadError: 'Could not load balance',
        historyLoadError: 'Could not load history',
        emptyHistory: 'No balance entries yet.',
        table: {
          date: 'Date',
          description: 'Description',
          source: 'Source',
          movement: 'Movement',
          balance: 'Balance',
        },
        sourceTypes: {
          RECONCILIATION: 'Reconciliation',
          BILL_PROVISION: 'Bill',
          MANUAL_ADJUSTMENT: 'Manual adjustment',
          REVERSAL: 'Reversal',
        },
        glPendingBadge: 'GL posting pending',
        glPendingBadgeTooltip:
          'This entry has not been posted to the general ledger yet. Posting happens on bill approval or on the next retry run.',
        adjustmentDialog: {
          entity: 'Entity',
          entityPlaceholder: 'Select the entity',
          title: 'Adjust balance (advance)',
          description: 'Record a credit or debit to the vendor advance balance.',
          type: 'Type',
          credit: 'Credit (increase balance)',
          debit: 'Debit (decrease balance)',
          amount: 'Amount',
          reason: 'Reason',
          reasonPlaceholder: 'Describe the reason for this adjustment (required)',
          effectiveDate: 'Effective date',
          contraAccount: 'Contra GL account',
          contraPlaceholder: 'Select GL account',
          zeroBalance: 'Zero balance',
          submit: 'Confirm adjustment',
          submitting: 'Saving...',
          cancel: 'Cancel',
          success: 'Balance adjusted successfully',
          error: 'Could not apply adjustment',
          liveBalanceError: 'Could not check the current balance. Try again.',
          debitAboveBalance: {
            message:
              'The current balance of {{entity}} is {{balance}}. This debit of {{amount}} leaves the balance at {{result}}. Confirm?',
            confirm: 'Confirm debit',
            back: 'Back',
            refused:
              'The balance changed and no longer covers this debit. Save again to review it.',
          },
          validation: {
            entityRequired: 'Select the entity for the adjustment.',
            reasonRequired: 'Reason is required.',
            amountInvalid: 'Enter a valid amount greater than zero.',
            contraRequired: 'Select a contra GL account.',
          },
        },
      },
      stats: {
        totalPaid12m: 'Total paid (12m)',
        totalPaid: 'Total paid',
        openBills: 'Open bills',
        openBillsCount: '{{count}} bills',
        lastTransaction: 'Last transaction',
        daysAgo: '{{count}} days ago',
        notAvailable: 'N/A',
      },
      mergeHistory: {
        tabTitle: 'Merge history',
        description: 'Records where this vendor absorbed another and bills were reassigned.',
        loading: 'Loading...',
        loadError: 'Could not load merge history.',
        table: {
          date: 'Date',
          user: 'User',
          sourceName: 'Source name',
          sourceCode: 'Code',
          sourceTaxId: 'CPF/CNPJ',
          bills: 'Bills reassigned',
        },
        snapshotNote: 'Values as captured for the source vendor at merge time.',
      },
    },
    vendorDocuments: {
      title: 'Vendor Documents',
      addButton: 'Add Document',
      noDocuments: 'No documents registered.',
      saveFirst: 'Save the vendor first to add documents.',
      loading: 'Loading documents...',
      loadError: 'Could not load documents.',
      loadErrorDescription: 'Check your connection and try again.',
      subtitle: 'Vendor documents and contracts',
      uploadContractHint:
        'Attach contracts, certificates or receipts. Contracts are analyzed by AI to prefill recurring bills.',
      dialogDescription:
        'Upload the document. Contracts are processed automatically to suggest recurring bills.',
      retry: 'Try again',
      table: {
        type: 'Type',
        name: 'Name',
        number: 'Number',
        issueDate: 'Issue Date',
        expiryDate: 'Expiry Date',
        status: 'Status',
        verified: 'Verified',
        actions: 'Actions',
      },
      status: {
        valid: 'Valid',
        expired: 'Expired',
        pendingRenewal: 'Pending Renewal',
        rejected: 'Rejected',
      },
      dialog: {
        add: 'Add Document',
        edit: 'Edit Document',
      },
      confirmations: {
        delete: 'Do you really want to delete this document?',
      },
      form: {
        entity: {
          label: 'Entity *',
          placeholder: 'Select the entity',
          required: "Select the document's entity",
        },
        file: {
          label: 'File *',
          description: 'Accepted formats: PDF, PNG, JPG, JPEG (max 10MB)',
        },
        fileTooLarge: 'File exceeds maximum limit of 10MB',
        fileRequired: 'Select a file to upload',
        documentType: {
          label: 'Document Type *',
          placeholder: 'Select a type',
          loading: 'Loading...',
          noTypes: 'No document types available',
        },
        documentName: {
          label: 'Document Name',
          placeholder: 'E.g. Service Agreement',
        },
        documentNumber: {
          label: 'Document Number',
          placeholder: 'E.g. CTR-2026-001',
        },
        issueDate: {
          label: 'Issue Date',
        },
        expiryDate: {
          label: 'Expiry Date',
        },
        issuingAuthority: {
          label: 'Issuing Authority',
        },
        verificationCode: {
          label: 'Verification Code',
        },
        status: {
          label: 'Status',
        },
        notes: {
          label: 'Notes',
          placeholder: 'Additional notes...',
        },
        submit: {
          add: 'Add',
          update: 'Update',
          saving: 'Saving...',
        },
      },
      actions: {
        extract: 'Extract recurring bill',
        extractShort: 'Recurring',
        view: 'View',
        download: 'Download',
        delete: 'Delete',
      },
      contractExtraction: {
        extracting: 'Processing contract with AI...',
        extractSuccess: 'Contract data extracted. Review fields and save recurring bill.',
        extractFailed:
          'Could not extract contract data automatically. The contract was uploaded successfully.',
      },
      toasts: {
        documentNotAvailable: 'Document unavailable for viewing',
        documentError: 'Could not load the document',
        uploadSuccess: 'Document uploaded successfully.',
        uploadError: 'Error uploading document.',
        duplicateDocument: 'This file was already uploaded for this entity.',
        deleteSuccess: 'Document deleted successfully.',
        deleteError: 'Error deleting document.',
      },
    },
  },
} as const;
